import { Injectable } from '@angular/core';
import { marked, Tokens } from 'marked';
import katex from 'katex';


@Injectable({
  providedIn: 'root',
})
export class MarkdownService {
  constructor() {
    marked.setOptions({
      breaks: true, // Enable line breaks
    });
  };

  private renderKaTeX(markdown: string): string {
      // Replace inline LaTeX math expressions (enclosed in $...$)
      return markdown.replace(/\$([^\$]+)\$/g, (match, math) => {
        try {
          return katex.renderToString(math, {
            throwOnError: false,
          });
        } catch {
          return match; // Return the original text if rendering fails
        }
      });
  }

  convertToHtml(markdown: string) {
    // Preprocess Markdown for KaTeX
    const preprocessedMarkdown = this.renderKaTeX(markdown);
    // Convert the preprocessed Markdown to HTML
    return marked(preprocessedMarkdown);
  }
}
